import type { CoreQuestionConfig } from '@dmp/qqms/data-access';
import { convertLinearQuestionToCoreQuestionConfig } from '../../../transformers/convert-linear-question-to-core-question-config';
import {
    isLinearAnswerItem,
    isLinearQuestionItem,
} from '../../state-type-guards';
import type { StoreState } from '../../state-types';

/**
 * Get Core Question config, prep data for Core Question patching.
 * Collect all data of a core question and its answers, then convert to core question config
 **/
export const getCoreQuestionConfig =
    (coreQuestionId: string) =>
    (state: StoreState): CoreQuestionConfig | undefined => {
        const actions = state.actions;
        const card = actions.getCard(coreQuestionId);

        if (!card || !isLinearQuestionItem(card)) {
            throw new Error('Only Linear Questions can be Core Questions');
        }

        const answers = actions
            .getCardAnswers(coreQuestionId)
            .filter(isLinearAnswerItem);

        return convertLinearQuestionToCoreQuestionConfig(card, answers);
    };
